module.exports = __webpack_public_path__ + "img/Bar.cdc4df83.svg";